import makeTable from '../../components/makeTable.jsx';

export const PropertiesTable = makeTable([
  ['Icon', 10],
  ['Origin', 90],
]);

export const UsersTable = makeTable([
  ['Avatar', 10],
  ['E-mail', 90],
]);
